import React from 'react';

const NavigateTo = (index, updateMobileNavOpen) => {
  if (updateMobileNavOpen) {
    updateMobileNavOpen({ isOpen: false });
  }

  window.PagesSweeper.slideTo(index, 1300);
};

const NavLinks = ({ NavLinkList, NavLinkListItem, NavLink, updateMobileNavOpen }) => (
  <NavLinkList>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(0, updateMobileNavOpen)}>About</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(1, updateMobileNavOpen)}>Services</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(2, updateMobileNavOpen)}>Work</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(3, updateMobileNavOpen)}>Our Clients</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(4, updateMobileNavOpen)}>For Developers</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(5, updateMobileNavOpen)}>Contact</NavLink>
    </NavLinkListItem>
    <NavLinkListItem>
      <NavLink onClick={() => NavigateTo(6, updateMobileNavOpen)}>Work with us</NavLink>
    </NavLinkListItem>
    <NavLinkListItem className="last">
      <NavLink
        href="https://blog.leafycode.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Blog
      </NavLink>
    </NavLinkListItem>
  </NavLinkList>
  );

export default NavLinks;



// WEBPACK FOOTER //
// ./src/shared/NavLinks.js